<template>
  <span class="small-loader" :class="{ primary, 'is-relative' : relative }"></span>
</template>

<script>
export default {
  name: 'SmallLoader',
  props: {
    primary: Boolean,
    relative: Boolean
  }
}
</script>

<style lang="scss">
@import '../../../scss/tools/*';
@import '../../../scss/mixins/*';

.small-loader{
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  height: 14px;
  width: 14px;
  margin: -7px 0 0 -7px;
  border: 3px rgba($white, 0.2) solid;
  border-top: 3px $white solid;
  border-radius: 50%;
  -webkit-animation: spin2 1s infinite linear;
  animation: spin2 1s infinite linear;
  @include transition();
  @include transform(translateY(-5px));

  &.primary{
    border: 3px rgba($primary, 0.2) solid;
    border-top: 3px $primary solid;
  }

  &.is-relative{
    position: absolute;
    top: initial;
    left: initial;
    float: right;
    @include transform(translateY(0));
  }
}

@keyframes spin2 {
  from {
    @include transform(translateY(-5px) rotate(0deg));
  }
  to {
    @include transform(translateY(-5px) rotate(359deg));
  }
}
</style>
